import type { FormEvent } from 'react';
import { useReactData } from '@/hooks/useReactData';

export const SubmitForm = (
  e: FormEvent,
  url: string,
  onSuccess: () => void,
  onFail: (message: string) => void,
): void => {
  e.preventDefault();
  // @ts-expect-error e.target is a form
  const formData = new FormData(e.target);
  const data = useReactData();
  if (data && data.csrf_token) formData.append('csrf_token', data.csrf_token);

  fetch(url, { method: 'post', body: formData })
    .then((res: Response) => {
      res
        .json()
        .then((data) => {
          if (data.success === true) {
            onSuccess();
          } else {
            // Use data.errors.email or fallback to generic data.message
            const message = data.errors?.email || data.message || 'Something went wrong, please try again later.';
            onFail(message);
          }
        })
        .catch((err) => {
          console.error('Error parsing JSON:', err);
        });
    })
    .catch(() => {
      onFail('Something went wrong, please try again later.');
    });
};
